export default theme => ({
  root: {
    width: '100%'
  },
  grid: {
    alignItems: 'flex-start'
  },
  filterChoiceContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginTop: '10px',
    marginLeft: '15px'
  },
  filterChoiceLabel: {
    marginBottom: theme.spacing(1)
  },
  filterChoiceButtons: {
    marginTop: theme.spacing(0.5)
  },
  field: {
    // spacing around each control in the filters row
    margin: theme.spacing(2)
  },
  textField: {
    width: '100%',
    maxWidth: '100%',
    //marginRight: theme.spacing.unit * 3
  },
  dropdownTopMargin: {
    marginTop: theme.spacing(1)
  },
  dropdownTopMinusMargin: {
    marginTop: -theme.spacing(3)
  },
  dropdownTopMinusMarginLastColumn: {
    marginTop: -theme.spacing(2)
  },
  portletFooter: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  fieldError: {
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
  footerButtons: {
    position: 'relative',
    display: 'flex'
  },
  footerButtonsCenter: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  footerButtonsLeftRight: {
    flex: 1
  },
  bold500: {
    fontWeight: 500
  }
});
